<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_CheckSetting')"
    width="800px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :show-close="false"
    :close-on-press-escape="false"
  >
    <el-button no="confirm" type="primary" @click="addHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :row-data="rowData"
      :column-defs="columnDefs"
      :check-sub-record="checkSubRecord"
      :deselect-sub-record="checkSubRecord"
      style="height:400px;margin-top: 5px"
      @gridReady="params=>{ gridApi = params.api}"
    />
    <template slot="footer">
      <el-button no="confirm" type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible = false;$emit('cancel', otherFieldBkg)">{{ $t('common.btn.back') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import {
  OCR_FIELD_CHANNEL, OCR_FIELD_CHANNEL_BOOK_NOTE,
  OCR_FIELD_IF_REQUIRED, OCR_FIELD_IF_REQUIRED_SAVE_JOB,
  OCR_FIELD_IF_SAME, OCR_FIELD_OP_OFFICE
} from '@/class/cargo/model/parameters/SystemConstants'
import { deepClone } from '@/utils'
import OperationRender from '@/components/OperationRender'
import { saveOcrFieldCheckConfig } from '@/api/ocrSet'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridAdvanceMultipleSelectEditor
  from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { deepCopy } from '@/utils/commonUtil'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'OcrFieldCheckConfigDialog',
  props: {
    visible: { type: Boolean, required: true },
    otherField: { type: Object, required: true },
    fieldDefineList: { type: Array, default: () => [] }, // 字段定义列表
    fieldDefineMap: { type: Object, default: () => {} } // 字段定义列表
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridAdvanceMultipleSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridSelectEditor
        },
        onSortChanged: this.rowDataChanged
      },
      selectRowsLabel: '',
      checkSubRecord: true,
      fieldDetailMap: null, // 字段详情map
      currentFieldDefineList: [], // 托书字段名称 下拉，过滤掉 ifCheck = true 的数据
      rowData: [], // 校验设置 数据
      OCR_FIELD_IF_REQUIRED, OCR_FIELD_CHANNEL, OCR_FIELD_IF_SAME,
      loading: null,
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_BookNoteFieldName'), field: 'code', width: 100, colId: 'code',
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          editable: params => !this.fieldDefineMap[params.data.code] || this.fieldDefineMap[params.data.code].ifRequired !== OCR_FIELD_IF_REQUIRED_SAVE_JOB.code, // 字段定义中【保存业务必填】的字段 无法编辑【字段名称、必填项】 无法删除
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: () => {
            return {
              selectProps: {
                filterable: true
              },
              options: this.currentFieldDefineList,
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              tagValue: 'code'
            }
          },
          valueFormatter: params => {
            return CommonState.getNameByCode(this.currentFieldDefineList, params.value)
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_IfRequired'), field: 'ifRequiredList', width: 100, colId: 'ifRequiredList',
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          editable: params => !this.fieldDefineMap[params.data.code] || this.fieldDefineMap[params.data.code].ifRequired !== OCR_FIELD_IF_REQUIRED_SAVE_JOB.code, // 字段定义中【保存业务必填】的字段 无法编辑【字段名称、必填项】 无法删除
          cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
          cellEditorParams: () => {
            return {
              selectProps: {
                multiple: true,
                tagValue: 'code',
                tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
                staticOptions: this.OCR_FIELD_IF_REQUIRED,
                filterable: true,
                filterTagNames: ['chineseName', 'englishName']
              }
            }
          },
          valueFormatter: (params) => {
            return this.multiLabelFunc(params.data.ifRequired, this.OCR_FIELD_IF_REQUIRED)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.multiLabelFunc(params.data.ifRequired, this.OCR_FIELD_IF_REQUIRED)
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Channel'), field: 'channelList', width: 100, colId: 'channelList',
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          editable: () => true,
          cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
          cellEditorParams: () => {
            return {
              selectProps: {
                multiple: true,
                tagValue: 'code',
                tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
                staticOptions: this.OCR_FIELD_CHANNEL,
                filterable: true,
                filterTagNames: ['chineseName', 'englishName']
              }
            }
          },
          valueFormatter: (params) => {
            return this.multiLabelFunc(params.data.channel, this.OCR_FIELD_CHANNEL)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.multiLabelFunc(params.data.channel, this.OCR_FIELD_CHANNEL)
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_IfSame'), field: 'ifSame', width: 100,
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          editable: params => params.data.channelList && params.data.channelList.length > 1,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: () => {
            return {
              selectProps: {
                tagValue: 'code',
                tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
                staticOptions: this.OCR_FIELD_IF_SAME,
                filterable: true,
                filterTagNames: ['chineseName', 'englishName']
              }
            }
          },
          valueFormatter: (params) => {
            return CommonState.getNameByCode(this.OCR_FIELD_IF_SAME, params.value)
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DefaultValue2'), field: 'defaultValue', width: 100,
          editable: params => params.data.code !== OCR_FIELD_OP_OFFICE.code, // 操作公司 不需要设置【为空默认值】；默认取当前分公司
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          colId: '',
          width: 120,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('CargoMsg.Cargo_OrderDelete'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.deleteHandler(params)
                },
                visible: (params) => !this.fieldDefineMap[params.code] || this.fieldDefineMap[params.code].ifRequired !== OCR_FIELD_IF_REQUIRED_SAVE_JOB.code // 字段定义中【保存业务必填】的字段 无法编辑【字段名称、必填项】 无法删除
              }
            ]
          }
        }
      ],
      otherFieldBkg: null,
      gridApi: null
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.init()
        }
      },
      immediate: true
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
    // ,
    // otherField() {
    //   // 初始化 托书字段 map
    //   this.fieldDefineMap = new Map(this.fieldDefineList.map(item => [item.code, item]))
    //
    //   // 初始化 托书字段名称 下拉
    //   for (const fieldDetail of this.otherField.ocrOtherFieldDetails) {
    //     if (!fieldDetail.ifCheck) {
    //       this.currentFieldDefineList.push(this.fieldDefineMap.get(fieldDetail.code))
    //     }
    //   }
    //
    //   // 初始化 数据
    //   this.rowData = deepClone(this.otherField.ocrOtherFieldDetails.filter(item => item.ifCheck))
    //
    //   // 初始化 数据 map
    //   this.fieldDetailMap = new Map(this.otherField.ocrOtherFieldDetails.map(item => [item.code, item]))
    // }
  },
  methods: {
    async init() {
      this.otherFieldBkg = deepCopy(this.otherField)

      // 初始化 托书字段名称 下拉
      for (const fieldDetail of this.otherField.ocrOtherFieldDetails) {
        this.currentFieldDefineList.push(this.fieldDefineMap[fieldDetail.code])
      }

      // 初始化 数据
      this.rowData = deepClone(this.otherField.ocrOtherFieldDetails.filter(item => item.ifCheck))

      // 初始化 多选数据数据
      this.rowData.map(item => {
        if (item.ifRequired) {
          item.ifRequiredList = item.ifRequired.split(',')
        }
        if (item.channel) {
          item.channelList = item.channel.split(',')
        }
      })

      // 初始化 数据 map
      this.fieldDetailMap = new Map(this.otherField.ocrOtherFieldDetails.map(item => [item.code, item]))
    },
    onReset() {
      this.gridOptions.api.deselectAll()
    },

    addHandler() {
      this.rowData.push({
        ifCheck: true,
        channel: OCR_FIELD_CHANNEL_BOOK_NOTE.code
      })
    },
    deleteHandler(params) {
      const index = this.rowData.indexOf(params)
      if (index !== -1) this.rowData.splice(index, 1)
      const fieldDetail = this.fieldDetailMap.get(params.code)
      if (fieldDetail) {
        // 清空校验数据
        fieldDetail.ifRequired = null
        fieldDetail.channel = null
        fieldDetail.ifSame = null
        fieldDetail.defaultValue = null
        fieldDetail.ifCheck = false
        fieldDetail.ifModified = true
      }
    },
    save() {
      const keySet = new Set()
      // 校验必填项
      for (const item of this.rowData) {
        if (keySet.has(item.code)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_BookFieldNameRepeat'))
          return
        }
        keySet.add(item.code)

        if (!item.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_BookNoteFieldName'))
          return
        }

        // if (!item.channel) {
        //   this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_Channel'))
        //   return
        // }

        if (item.channel && item.channel.indexOf(',') !== -1 && !item.ifSame) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_IfSame'))
          return
        }
      }

      this.loading = getLoading4Cxt(this)
      saveOcrFieldCheckConfig(this.otherField).then(res => {
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.$emit('saveSuccess')
        this.innerVisible = false
      }).finally(() => {
        this.loading.close()
      })
    },
    onCellChange(params) {
      if (params.newValue === params.oldValue) {
        return
      }
      switch (params.colDef.field) {
        case 'code': {
          const existFields = this.rowData.filter(row => row.code === params.newValue)
          if (existFields && existFields.length > 1) {
            this.$message.warning(this.$t('CargoMsg.Cargo_BookFieldNameRepeat'))
            params.data.code = params.oldValue
            this.gridApi.refreshCells({ force: true })
            break
          }
          // 操作公司不需要设置【为空默认值】；默认取当前分公司
          if (params.newValue === OCR_FIELD_OP_OFFICE.code) {
            params.data.defaultValue = null
            this.gridApi.refreshCells({ force: true })
          }
          const newFieldDetail = this.fieldDetailMap.get(params.newValue)
          const oldFieldDetail = this.fieldDetailMap.get(params.oldValue)
          if (newFieldDetail) {
            // 赋值校验数据
            newFieldDetail.ifRequired = params.data.ifRequired
            newFieldDetail.channel = params.data.channel
            newFieldDetail.ifSame = params.data.ifSame
            newFieldDetail.defaultValue = params.data.defaultValue
            newFieldDetail.ifCheck = params.data.ifCheck
            newFieldDetail.ifModified = true
          }
          if (oldFieldDetail) {
            // 清空校验数据
            oldFieldDetail.ifRequired = null
            oldFieldDetail.channel = null
            oldFieldDetail.ifSame = null
            oldFieldDetail.defaultValue = null
            oldFieldDetail.ifCheck = false
            oldFieldDetail.ifModified = true
          }
        }
          break
        case 'ifRequiredList': {
          if (params.data.ifRequiredList) {
            params.data.ifRequired = params.data.ifRequiredList.join(',')
          } else {
            params.data.ifRequired = ''
          }
          const fieldDetail = this.fieldDetailMap.get(params.data.code)
          fieldDetail.ifRequired = params.data.ifRequired
          fieldDetail.ifModified = true
        }
          break
        case 'channelList': {
          if (params.data.channelList) {
            params.data.channel = params.data.channelList.join(',')
            if (params.data.channelList.length < 2) {
              params.data.ifSame = null
            }
          } else {
            params.data.channel = null
          }
          const fieldDetail = this.fieldDetailMap.get(params.data.code)
          fieldDetail.channel = params.data.channel
          fieldDetail.ifModified = true
        }
          break
        default:
          this.fieldDetailMap.get(params.data.code)[params.colDef.field] = params.newValue
          console.log('params.newValue:', params.newValue)
          console.log('this.fieldDetailMap.get(params.data.code)[params.colDef.field]：', this.fieldDetailMap.get(params.data.code)[params.colDef.field])
          this.fieldDetailMap.get(params.data.code)['ifModified'] = true
          break
      }

      // field: params.colDef.field,
      //   value: params.newValue,
      //   originalValue: params.oldValue
    },
    multiLabelFunc(str, items) {
      const labelList = []
      if (str) {
        const array = str.split(',')
        for (const item of array) {
          labelList.push(CommonState.getNameByCode(items, item))
        }
      }
      return labelList.join(',')
    }
  }
}
</script>
